import axios from 'axios'

const isDev = process.env.NODE_ENV === 'development'
const isStagingHost = window.location.hostname.split('.').includes('staging')

const envSubDomain = isStagingHost || isDev ? '.staging' : ''

// In dev mode use local proxy to enable mocking specific endpoints
const baseURL = isDev
  ? '/api/logistics'
  : `https://logistics-feature-service${envSubDomain}.dostaevsky.ru`

const logisticsHttp = axios.create({
  baseURL
})

// Добавим токен, если нужно
logisticsHttp.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Token ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// Обработка ответа
logisticsHttp.interceptors.response.use(
  response => response.data,
  error => {
    console.error('Logistics service error', error)
    return Promise.reject(error.response || error)
  }
)

export default logisticsHttp
